<div class="task-container">
    <ng-dynamic-form 
        #domainForm 
        *ngIf="formSchema" 
        [formData]="formData" 
        [formSchema]="formSchema" 
        [formMaxHeight]="false" 
        [translationData]="file"
        (actionEmitter)="fileActionChange($event)"
    ></ng-dynamic-form>
    <div>
        <button *ngIf="!hideSaveBtn" tsl-button size="medium" color="blue" filled (click)="submit()">{{ translate.get(saveButtonLabel) }}</button>
        <button tsl-button size="small" color="black" outline (click)="onNoClick()" i18n="@@Close"
            t="Close">Close</button>
    </div>
</div>